import type { ReactElement, ReactNode } from 'react'
import { ListCard } from 'app/components/lists/board/ListCard'
import type { ListBoardCardDrag } from 'app/components/lists/board/boardTypes'
import { type CardContext, RecipeSections } from 'app/components/lists/card/RecipeSections'
import type { RecipeAndSubject } from 'lib/cardRecipe'

// A shared default: oxlint's rule against a fresh object literal as a default prop value.
const NO_CONTEXT: CardContext = {}

/** Every list card: the shared frame, dressed by the recipe, around the recipe's sections in order. */
export function RecipeCard({
  drag,
  onOpen,
  onPress,
  href,
  actions,
  context = NO_CONTEXT,
  ...paired
}: RecipeAndSubject & {
  drag: ListBoardCardDrag
  onOpen: () => void
  onPress?: () => void
  href?: string
  actions?: ReactNode
  context?: CardContext
}): ReactElement {
  // Destructured apart, recipe and subject would lose their pairing; RecipeSections needs it.
  const { recipe, subject } = paired
  const { frame } = recipe
  const sections = <RecipeSections {...paired} context={context} />
  return (
    <ListCard
      id={subject.kind === `contact` ? subject.contact.id : subject.card.id}
      dragging={drag.dragging}
      onDragStart={drag.onDragStart}
      onDragEnd={drag.onDragEnd}
      onOpen={onOpen}
      onPress={onPress}
      liftable={frame.liftable}
      href={href}
      actions={actions}
      className={frame.className}
      select={drag.select}
      name={(subject.kind === `contact` ? subject.contact.name : subject.card.name) ?? undefined}
    >
      {frame.body ? <div className={frame.body}>{sections}</div> : sections}
    </ListCard>
  )
}
